import * as React from "react";
const UpToDateSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M38.703 25.633c-.412-.431-.839-.875-1-1.266-.148-.358-.157-.95-.166-1.524-.016-1.068-.033-2.278-.874-3.119-.842-.84-2.051-.858-3.119-.875-.574-.009-1.167-.017-1.524-.166-.39-.16-.835-.587-1.266-1-.755-.725-1.612-1.546-2.754-1.546s-1.998.821-2.754 1.546c-.431.413-.875.84-1.265 1-.356.149-.951.157-1.525.166-1.068.017-2.277.034-3.119.875-.84.841-.853 2.051-.875 3.119-.008.574-.017 1.166-.166 1.524-.16.39-.587.835-1 1.266-.725.754-1.546 1.612-1.546 2.754s.821 1.998 1.547 2.754c.412.43.838.875 1 1.265.148.358.157.95.165 1.525.017 1.067.034 2.277.875 3.118.842.841 2.051.859 3.119.875.574.009 1.167.018 1.524.166.39.161.835.588 1.266 1 .755.725 1.612 1.547 2.754 1.547s1.998-.822 2.754-1.547c.431-.412.875-.839 1.265-1 .358-.148.951-.157 1.525-.166 1.068-.016 2.277-.034 3.119-.875.84-.84.858-2.05.875-3.118.008-.574.017-1.167.166-1.525.16-.39.587-.834 1-1.265.725-.755 1.546-1.612 1.546-2.754s-.821-1.999-1.547-2.754ZM37.44 29.93c-.524.547-1.066 1.112-1.354 1.807-.276.667-.288 1.43-.298 2.168-.011.765-.023 1.567-.364 1.906-.34.34-1.136.352-1.906.363-.738.011-1.5.023-2.168.299-.694.288-1.26.83-1.807 1.354-.547.524-1.105 1.06-1.543 1.06-.438 0-1-.538-1.543-1.06-.543-.522-1.113-1.066-1.807-1.354-.667-.276-1.43-.288-2.168-.299-.766-.01-1.567-.023-1.906-.363-.34-.34-.353-1.136-.364-1.906-.01-.739-.023-1.5-.298-2.168-.288-.695-.83-1.26-1.354-1.807-.524-.547-1.06-1.106-1.06-1.543 0-.438.538-1.001 1.06-1.544.522-.542 1.066-1.112 1.354-1.806.275-.668.288-1.43.298-2.168.011-.766.023-1.568.364-1.907.34-.339 1.136-.352 1.906-.363.738-.01 1.5-.023 2.168-.298.694-.288 1.26-.83 1.807-1.354.547-.524 1.105-1.06 1.543-1.06.438 0 1 .538 1.543 1.06.543.521 1.113 1.066 1.807 1.354.667.275 1.43.287 2.168.298.766.011 1.567.023 1.906.363.34.34.353 1.137.364 1.907.01.738.023 1.5.298 2.168.288.694.83 1.26 1.354 1.806.524.547 1.06 1.106 1.06 1.544 0 .437-.538 1-1.06 1.543Zm-4.446-4.787a.874.874 0 0 1 0 1.238l-6.125 6.125a.876.876 0 0 1-1.238 0l-2.625-2.625a.876.876 0 0 1 1.238-1.238l2.006 2.007 5.506-5.507a.876.876 0 0 1 1.238 0Z"
    />
  </svg>
);
export default UpToDateSVG;
